<template>
  <div>
    <common-dialog
      ref="dialog"
      width="650px"
      line-form
      show-save-button
      unit="仓库"
      edit-title
      id-key="WarehouseId"
      :data="data"
      form-label-width="110px"
      @create-opened="onCreateOpened"
      @edit-opened="openEditOpened"
      @opened="$refs.typeSelect.init()"
      @closed="$refs.typeSelect.clear()"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="仓库类别" prop="ClassId">
          <type-select ref="typeSelect" v-model="data.ClassId" />
        </el-form-item>
        <el-form-item label="仓库类型" prop="WarehouseType">
          <el-radio-group v-model="data.WarehouseType" class="detail-span">
            <el-radio :label="1">库存仓</el-radio>
            <el-radio :label="2">车间仓</el-radio>
            <el-radio :label="3">委外仓</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="仓库编码" prop="WarehouseNo">
           <span v-if="Mode==0" class="detail-span">{{data.WarehouseNo}}</span>
              <el-input v-else v-model="data.WarehouseNo" placeholder="请输入仓库编码"></el-input>
        </el-form-item>
        <el-form-item label="仓库名称" prop="WarehouseName">
          <el-input v-model="data.WarehouseName" placeholder="请输入仓库名称" />
        </el-form-item>
        <el-form-item label="仓库备注" prop="Remark">
          <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注" />
        </el-form-item>
        <el-form-item label="仓库地址" prop="WarehouseAddress">
          <el-input type="textarea" v-model="data.WarehouseAddress" placeholder="请输入地址" />
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input v-model="data.Sn" v-int style="width: 100px;" />
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
           <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="参与可用量" class="notBottom">
          <el-checkbox v-model="data.IsCount" :true-label="1" :false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="允许零库存出库" class="notBottom" >
          <el-checkbox v-model="data.IsZeroCheckOut" :true-label="1" :false-label="0" ></el-checkbox>
        </el-form-item>
        <el-form-item label="启用库位管理" class="notBottom" >
          <el-checkbox v-model="data.IsWarehousePosition" :true-label="1" :false-label="0" ></el-checkbox>
        </el-form-item>
     
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import typeSelect from "./type/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    typeSelect,
  },
  data() {
    return {
      data: {
        WarehouseId: 0,
        WarehouseNo: "",
        WarehouseName: "",
        WarehouseType: 0, //仓库类型 - 0:库存仓 1:生产仓
        ClassId: 0,
        IsCount: 0,
        IsZeroCheckOut: 0,
        IsWarehousePosition:0,
        ClassName: "",
        Remark: "",
        Sn: 0,
        Status: 1,
      },
      classApi: require("@/api/ba/class").default,
      api: require("@/api/ba/warehouse").default,
      Mode:1,
      classList:[],
      code_api: require("@/api/sy/serialCode").default,
      rules: {
        WarehouseNo: [{ required: true, message: "仓库编码不能为空" }],
        WarehouseName: [{ required: true, message: "仓库名称不能为空" }],
        ClassId: [{ required: true, message: "请选择仓库类别" }],
        Sn: [{ required: true, message: "序号不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    serialCode(){
      this.code_api.previewNo("仓库").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.WarehouseNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取仓库编号失败");
        }
      });
    },
    onCreateOpened() {
      this.serialCode()
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
    openEditOpened(data){
      console.log('data',data);
      this.api.info(data.WarehouseId).then(res=>{
        if(res.Code == 0) this.data = res.Data
      })
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>